import styled from 'styled-components';

const __justifyContent = props => {
    if (props.justifyContent) {
        return props.justifyContent;
    }

    return '';
};

export const FlexBox = styled.div`
    display: flex;
    justify-content: ${__justifyContent}
`;

